class CustomerGalleryFilters extends HTMLElement {
  constructor () {
    super()
    this.addScrollListener()
    this.addFilterClickListeners()
  }

  addScrollListener () {
    this.filtersContainer.addEventListener('scroll', () => this.updateFaders(), { passive: true })
    window.addEventListener('resize', () => this.updateFaders())
    // Initialize faders
    this.updateFaders()
  }

  addFilterClickListeners () {
    this.filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        this.scrollFilterIntoView(filter)
      })
    })
  }

  scrollFilterIntoView (filter) {
    const container = this.filtersContainer
    const filterLeft = filter.offsetLeft
    const filterWidth = filter.offsetWidth
    const containerWidth = container.clientWidth

    // Calculate the new scroll position to center the filter
    let newScrollLeft = filterLeft - containerWidth / 2 + filterWidth / 2

    // Ensure the new scroll position is within bounds
    newScrollLeft = Math.max(0, Math.min(newScrollLeft, container.scrollWidth - containerWidth))

    container.scrollTo({
      left: newScrollLeft,
      behavior: 'smooth',
    })
  }

  updateFaders () {
    const container = this.filtersContainer
    const isScrollable = container.scrollWidth > container.clientWidth

    if (!isScrollable) {
      this.faderLeft.classList.add('opacity-0')
      this.faderRight.classList.add('opacity-0')
      return
    }

    const scrollLeft = container.scrollLeft
    const clientWidth = container.clientWidth
    const scrollWidth = container.scrollWidth

    const atStart = scrollLeft <= 0
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 1

    this.faderLeft.classList.toggle('opacity-0', atStart)
    this.faderLeft.classList.toggle('opacity-100', !atStart)

    this.faderRight.classList.toggle('opacity-0', atEnd)
    this.faderRight.classList.toggle('opacity-100', !atEnd)
  }

  get filters () {
    return this.querySelectorAll('.customer-gallery__gallery-filter')
  }

  get filtersContainer () {
    return this.querySelector('.customer-gallery__gallery-filters-container')
  }

  get faderLeft () {
    return this.querySelector('.customer-gallery__gallery-filters-fader--left')
  }

  get faderRight () {
    return this.querySelector('.customer-gallery__gallery-filters-fader--right')
  }
}

if (!customElements.get('customer-gallery-filters')) {
  customElements.define('customer-gallery-filters', CustomerGalleryFilters)
}
